import { Typography } from 'components/Typography';
import { useDisclose } from 'hooks/utilHooks';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Button,
  ButtonGroup,
  Grid,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';

type Props = {
  representantUrl?: string;
};

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: 220,
    padding: 10,
  },
}));

export const RepresentativeShareLink: React.FC<Props> = ({
  representantUrl,
}) => {
  const { isOpen, onOpen, onClose } = useDisclose();

  if (!representantUrl) {
    return null;
  }

  const handleOnClick = async () => {
    await navigator.clipboard.writeText(representantUrl);
    onOpen();
  };

  return (
    <Grid item mt={1}>
      <Typography
        mb={1}
        pl={4}
        color="#757575"
        fontSize={14}
        fontWeight={500}
        letterSpacing={1.5}
        textTransform="uppercase"
      >
        Compartilhar link do representante
      </Typography>

      <Grid item justifyContent="flex-end">
        <ButtonGroup
          disableElevation
          variant="contained"
          sx={{ border: '1px solid #8E8E8E' }}
        >
          <Typography mx={4} my={1} color="#757575" textAlign="center">
            {representantUrl}
          </Typography>
          <StyledTooltip
            arrow
            open={isOpen}
            placement="top"
            onClose={onClose}
            title={'Copiado'}
          >
            <Button onClick={handleOnClick} sx={{ bgcolor: '#E5E5E5' }}>
              <ContentCopyIcon />
            </Button>
          </StyledTooltip>
        </ButtonGroup>
      </Grid>
    </Grid>
  );
};

